import { connect } from 'react-redux';
import { change } from 'redux-form';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { AgeType } from '@eti/schema-types';
import { useMemo, useState } from 'react';
import { parseJsonProp } from '../../common/utils/productCardProps';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useProductData } from '../../common/hook/useProductData';
import { getSelected } from '../../single-choice/utils/selection';
import { AIRPORT_TRANSFER } from '../../products';
import { ProductCardLayoutType } from '../../common/models/product';
import { standardGrid } from '../../common/main-layout/styles';
import { getOperatorList, NoneOption, sortOperatorList, validateAirportTransferTranslations } from './utils';
import AirportTransferSelection from './AirportTransferSelection';
import AirportTransferDrawer from './AiportTransferDrawer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const airportTransferGrid = css`
  ${standardGrid}

  .illustration {
    grid-area: 1 / 1 / 3 / 2;
  }

  .cardSelection {
    grid-area: 3 / 1 / 4 / 3;
  }

  .goWithout {
    grid-area: 4 / 1 / 5 / 3;
  }
`;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = AIRPORT_TRANSFER;
const sharedTexts = {
  abstractContent: 'airportTransferAbstract',
  readMoreContent: 'airportTransferReadMoreModalContent',
  title: 'airportTransferTitle',
  upSell: 'airportTransferUpSellText',
  generalPurpose: 'airportTransferGeneralPurpose'
};
const AirportTransfer = _ref => {
  var _productData$extraPro;
  let {
    form,
    layoutType = ProductCardLayoutType.Main,
    isSelected,
    order,
    productPosition,
    sellSpecification,
    className,
    dispatch
  } = _ref;
  const {
    t
  } = useTranslation();
  const sortedOperatorList = useMemo(() => {
    const product = getProduct(PRODUCT_ID, order, 'none');
    if (!product) {
      return null;
    }
    const operatorList = getOperatorList(t, isSelected, product, sellSpecification);
    if (!operatorList || operatorList.length === 0) {
      return null;
    }
    return sortOperatorList(operatorList);
  }, [t, isSelected, order, sellSpecification]);
  const {
    productData,
    rootElement,
    translation
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    sellSpecification,
    texts: sharedTexts
  });
  const [drawerOperator, setDrawerOperator] = useState(null);
  if (!(productData && sortedOperatorList)) {
    return null;
  }
  const translated = parseJsonProp(translation.generalPurpose);
  if (!validateAirportTransferTranslations(translated)) {
    return null;
  }
  const handleChange = e => {
    const value = e === null || e === void 0 ? void 0 : e.target.value;
    const priceRaw = value && value !== NoneOption ? sortedOperatorList.filter(operator => String(operator.externalChoiceId) === value)[0].priceRaw : 0;
    const travelersWithoutInfants = order.travelers.filter(traveler => traveler.ageType !== AgeType.Inf);
    dispatch(change(form, PRODUCT_NAME, {
      value,
      selectionTravelerExternalChoice: travelersWithoutInfants.map(traveler => {
        return {
          travelerId: traveler.id,
          choiceId: value,
          price: priceRaw
        };
      })
    }));
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    coreComponentsRenderConfig: ['Illustration', 'Header', 'Body'],
    customGrid: airportTransferGrid,
    productData: productData,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(AirportTransferSelection, {
      errorMessage: (_productData$extraPro = productData.extraProps) === null || _productData$extraPro === void 0 ? void 0 : _productData$extraPro.selectOneLabel,
      handleOpenDrawer: setDrawerOperator,
      handleRadioChange: handleChange,
      operatorList: sortedOperatorList,
      productName: PRODUCT_NAME,
      translation: translated
    }), drawerOperator && /*#__PURE__*/_jsx(AirportTransferDrawer, {
      handleClose: () => setDrawerOperator(null),
      operator: drawerOperator,
      translation: translated
    })]
  });
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  const productName = AIRPORT_TRANSFER.name;
  return {
    isSelected: getSelected(productName, form)(state)
  };
};
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(AirportTransfer);
//# sourceMappingURL=AirportTransfer.js.map